<template>
    <div class="flex items-center relative">

          <div v-show="isHidden">
            <p>
              {{content}}<a v-on:click="isHidden = !isHidden" class="text-xxs align-middle cursor-pointer"><i aria-hidden="true" class="material-icons align-middle text-sm mx-1">edit</i>Change</a>
            </p>
          </div>
          <div v-if="!isHidden" class="flex w-full items-center">
            <div class="flex pr-1 w-10/12">
              <input class="w-full" id="groupName" type="text"
                     @keydown.enter="putItem"
                     v-model="value"
                     v-mask="vmask"
                     autofocus
              />
            </div>
            <div class="w-2/12" v-show="isSure">
              <a v-on:click="isSure = !isSure" class="commitbutton p-0 inline-block w-10 cursor-pointer"><i aria-hidden="true" class="material-icons align-middle text-3xl">check</i></a>
            </div>
          </div>
          <div v-if="!isSure" class="bg-red-600 text-white w-full p-3 absolute top-0 text-sm z-50" v-click-outside="onClickOutside">
              {{confirmtext}} <br>
              <button v-on:click="putItem" type="submit" class="btn text-sm bg-white text-red-700 commitbutton mt-1 rounded px-3 py-1"><i aria-hidden="true" class="material-icons align-middle text-3xl">check</i>Yes, Do It</button>
          </div>
      </div>
</template>

<script>
import vClickOutside from 'v-click-outside'
import VueMask from 'v-mask'
Vue.use(VueMask);
import axios from 'axios'


  export default {

        props: {
            content: '',
            route:'',
            routeparam:'',
            confirmtext: {
              default: 'Are You Sure?',
            },
            buttonname: {
              default: 'Change',
            },
            buttonicon: {
              default: 'edit',
            },
            buttonsize: {
              default: 'text-xs',
            },
            inputmask: {
              default: 'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX',
            },
        },

        data() {
          return {
            isHidden: true,
            isSure: true,
            success: false,
            loaded: true,
            value: '',
            vmask: this.inputmask,
          }
        },
        
        directives: {
          clickOutside: vClickOutside.directive
        },
        
        methods: {
          onClickOutside (event) {
              this.isSure = !this.isSure
          },
          
          formfocus() {
              document.getElementById("groupName").focus();
          },
          mounted(){
            this.formfocus()
          },

          putItem: function (event) {
            if (this.loaded) {
              this.loaded = false;
              this.success = false;
              $( ".commitbutton").addClass( "loading" );
              axios.put(this.route,
                { [this.routeparam]: this.value }
              )
              .then(function (response) {
                  console.log(response);
                }).then(function (event) {
                  location.reload();
                })
            };
          }

        },
      }
</script>
